import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

/**
 * Gets spy profile by id
 */
export const getSpy = async ({ id }) =>
  callAuthorizedGraphQLEndpoint(
    `query ($id:ID!) {
      spy(spyId:$id){
        id
        firstName
        lastName
        status
        blockedReason
        referralCode
        businessNumber
        insuranceNumber
        documentsProvided
        email
        extendedMissionsLimit
        fixedPriceMissions
        flyerCount
        isVerified
        itemCount
        memberSince
        mobilePhone
        profilePicture
        rating
        withholdPay
        isTeamLeader
        restrictedMissionType
        emailVerificationLink
        paymentDetails {
          accountName
          accountNumber
          branchNumber
        }
        city {
          id
          name
        }
        formW9 {
          fileName
          fileSaveTime
        }
        signedLegalDocuments {
          totalCount
          edges {
            node {
              dateTime
              legalDocument {
                id
                url
                name
              }
            }
          }
        }
      }
    }`,
    { id },
  )

export const getSpyActivity = async variables => {
  const query = `query ($spyId:ID! $first:Int $after:String) {
    spy(spyId:$spyId) {
      missions (first:$first after:$after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
             id
             status
             timeRangeStart
             timeOfDay
             user {
               firstName
               lastName
             }
             location{
               name
              }
             client{
               name
             }
             spyInformation{
              shift{
                id
              }
            }
          }
        }
      }    
    }
  }`
  const req = await callAuthorizedGraphQLEndpoint(query, variables)
  return req.json()
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spies/gql.js